import React from 'react';
import { sendExportAllPeopleRequest } from 'misc/async_reports_helper';
import ActionButton from '../shared/ActionButton';

const ExportAllPeopleButton = ({ activeGroupId }) => {
  return (
    <div className="d-f ai-c">
      <ActionButton
        label={
          activeGroupId
            ? t('groups.show.export_selected_group')
            : t('groups.show.export_all_people')
        }
        handleClick={e => sendExportAllPeopleRequest(activeGroupId)}
        iconName="download"
        customButtonStyles="u-linkBtn c-p ff-ss"
      />
    </div>
  );
};

export default ExportAllPeopleButton;
